module.exports = __webpack_public_path__ + "img/poin.d3497d1e.png";